const complianceMenuItems = [
  {
    id: "annual-reports",
    label: "Annual Reports",
    path: "/compliance/annual-reports",
  },
  {
    id: "mgt-7",
    label: "Annual Returns",
    path: "/compliance/mgt-7",
  },
  {
    id: "csr",
    label: "CSR",
    pageTitle: "Corporate Social Responsibility",
    path: "/compliance/csr",
  },
  {
    id: "nmdfc-policies",
    label: "NMDFC Policies",
    path: "/compliance/nmdfc-policies",
  },
  {
    id: "lending-policy",
    label: "Lending Policy",
    path: "/compliance/lending-policy",
  },
  {
    id: "memorandum-of-understanding",
    label: "Memorandum of Understanding",
    path: "/compliance/memorandum-of-understanding",
  },
  {
    id: "memorandum-of-association",
    label: "Memorandum of Association",
    path: "/compliance/memorandum-of-association",
  },
];

export const normalizeComplianceSection = (section) => {
  const matchedSection = complianceMenuItems.find((item) => item.id === section);
  return matchedSection ? matchedSection.id : complianceMenuItems[0].id;
};

export const getComplianceSection = (section) =>
  complianceMenuItems.find((item) => item.id === section) ||
  complianceMenuItems[0];

export default complianceMenuItems;
